import type {
  RunSelectorGroupingKey,
  WorkspacePageContent,
} from '../../store/thread';
import {agentPageContextChannel, type AgentPageContextReader} from '../channel';

/** ViewIdentity is the workspace view's identity, published as one value. */
type ViewIdentity = Pick<
  WorkspacePageContent,
  'viewId' | 'viewName' | 'viewType' | 'viewScope'
>;

export const viewIdentity = agentPageContextChannel<ViewIdentity>();
export const runSelectorGroupingKeys =
  agentPageContextChannel<RunSelectorGroupingKey[]>();
export const panelSearchQuery = agentPageContextChannel<string>();
export const runCountFiltered = agentPageContextChannel<number>();
export const runCountTotal = agentPageContextChannel<number>();
export const runCountListed = agentPageContextChannel<number>();
export const runsFilter = agentPageContextChannel<string>();

/** workspaceReducer assembles the workspace page content from its channels. */
export const workspaceReducer = (
  read: AgentPageContextReader
): Omit<WorkspacePageContent, 'type'> => ({
  ...read.one(viewIdentity),
  runCountTotal: read.one(runCountTotal),
  runCountFiltered: read.one(runCountFiltered),
  runCountListed: read.one(runCountListed),
  runFiltersExpression: read.one(runsFilter),
  panelSearchQuery: read.one(panelSearchQuery),
  runSelectorGrouping: read.one(runSelectorGroupingKeys),
});
